module.exports = __webpack_public_path__ + "img/left.cdc8c713.png";